import i18next from 'i18next';
import moment from 'moment-timezone';

import { CATEGORY_TYPES_OBJECT } from '@commons/constants/categoryTypes';
import { getUserTimezone } from '@commons/utils/date';

export const getEntityTypesChoices = () => [
  { key: 'RECIPES', name: i18next.t('FEATURE.ADMIN.RECIPES') },
  { key: 'INGREDIENTS', name: i18next.t('FEATURE.ADMIN.INGREDIENTS') },
];

export const ENTITY_TYPES_TO_CATEGORY_TYPES = {
  RECIPES: CATEGORY_TYPES_OBJECT.RECIPE,
  INGREDIENTS: CATEGORY_TYPES_OBJECT.INGREDIENT,
};

/**
 * Get the correct time slots to use in sales planning or production planning
 *
 * @param {Set} productTimeSlotIdsSet - A set of product time slot ids
 * @param {string} params.selectedDate - The selected date
 * @param {Store} params.selectedStore - The selected store
 *
 * @returns {Array} - Correct time slots to use
 */
export const getTimeSlotsToUse = (productTimeSlotIdsSet, { selectedDate, selectedStore }) => {
  const TODAY = moment.tz(getUserTimezone());

  let timeSlotsToUse = [];

  /*
    For future or current dates, we use active time slots. For past dates
    we use time slots that contain product data
   */
  if (moment(selectedDate).isSameOrAfter(TODAY, 'day')) {
    const activeTimeSlots = selectedStore.productionTimeSlots.filter(({ active }) => active);

    timeSlotsToUse = activeTimeSlots;

    // If there are more than one time slot, we need to filter out the default timeslot
    if (activeTimeSlots.length > 1) {
      timeSlotsToUse = activeTimeSlots.filter(({ name }) => name !== null);
    }

    return timeSlotsToUse;
  }

  const associatedTimeSlots = selectedStore.productionTimeSlots.filter(({ id }) =>
    productTimeSlotIdsSet.has(id),
  );

  timeSlotsToUse = associatedTimeSlots;

  // No data on any timeslot, we use the default timeslot
  if (!timeSlotsToUse.length) {
    timeSlotsToUse = [selectedStore.productionTimeSlots.find(({ name }) => name === null)];
  }

  return timeSlotsToUse;
};
